import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

export default function AuthCallback() {
  const { loginWithSessionId } = useAuth();
  const nav = useNavigate();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    const sid = m?.[1];
    if (!sid) { nav("/login"); return; }
    (async () => {
      try {
        const u = await loginWithSessionId(sid);
        toast.success("Accesso effettuato con Google");
        // clean up hash
        window.history.replaceState(null, "", window.location.pathname);
        nav(u.role === "admin" ? "/admin" : "/le-mie-prenotazioni", { state: { user: u } });
      } catch (e) {
        toast.error("Errore autenticazione Google");
        nav("/login");
      }
    })();
  }, [loginWithSessionId, nav]);

  return (
    <div className="min-h-[60vh] flex items-center justify-center">
      <div className="text-center">
        <div className="font-display text-2xl">Accesso in corso…</div>
        <div className="text-sm text-foreground/60 mt-2">Stiamo autenticando la tua sessione Google.</div>
      </div>
    </div>
  );
}
